function getFilterOptions() {
  return [
    {
      label: "Scheduled",
      value: "dated",
    },
    {
      label: "Private Treaty",
      value: "private_treaty",
    },
    {
      label: "Coming Soon",
      value: "undated",
    },
    
  ];
}

function getFilterOption(data: any) {
  let prices = getFilterOptions();
  return prices.filter((item: any) => {
    // console.log({data});
    return data.slug.includes(item.value);
  });
}

export { getFilterOptions, getFilterOption };
